function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/dist/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/dist/plugins/zoom";
import "yet-another-react-lightbox/dist/styles.css";
import ReactPlayer from "react-player";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ProjectGalleryNew(_ref) {
  var projectGallery = _ref.projectGallery,
    config = _ref.config,
    isDosti = _ref.isDosti;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var images = projectGallery === null || projectGallery === void 0 ? void 0 : projectGallery.filter(function (image) {
    return image.urlType === "IMAGE";
  });
  var videos = projectGallery === null || projectGallery === void 0 ? void 0 : projectGallery.filter(function (image) {
    return image.urlType === "VIDEO";
  });
  return /*#__PURE__*/_jsxs("div", {
    id: "gallery",
    className: "mt-5",
    children: [(images === null || images === void 0 ? void 0 : images.length) > 0 && /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col",
      children: [/*#__PURE__*/_jsx("h4", {
        className: "z-10 text-xl mt-4  ".concat(config !== null && config !== void 0 && config.darkMode ? "text-primary" : "text-[#130E2F]", " mb-2 font-bold ").concat(config === null || config === void 0 ? void 0 : config.fontTitle),
        children: "Gallery"
      }), /*#__PURE__*/_jsx("div", {
        className: "z-10 grid grid-cols-3 md:grid-cols-7 lg:grid-cols-5 xl:grid-cols-7 auto-rows-fr w-full gap-2",
        children: images.slice(0, 18).map(function (image, i) {
          return /*#__PURE__*/_jsx("img", {
            onClick: function onClick() {
              return setIndex(i);
            },
            className: "".concat(i == 0 && images.length > 10 ? "row-span-2 col-span-2 min-h-[100px] xl:min-h-[120px] h-full" : "row-span-1 h-[100px] xl:h-[120px] ", " object-cover w-full cursor-pointer"),
            src: image.url
          }, image.url + i);
        })
      }), images.length > 18 && /*#__PURE__*/_jsxs("button", {
        onClick: function onClick() {
          return setIndex(18);
        },
        className: "".concat(config === null || config === void 0 ? void 0 : config.fontBody, " float-right mt-1 z-10 bg-gray-100 py-1 px-2 font-medium cursor-pointer"),
        children: ["+ ", projectGallery.length - 18 + " more images"]
      }), /*#__PURE__*/_jsx(Lightbox, {
        slides: images.map(function (image) {
          return {
            src: image.url,
            title: isDosti ? "" : image.caption
          };
        }),
        open: index >= 0,
        index: index,
        close: function close() {
          return setIndex(-1);
        },
        plugins: [Fullscreen, Zoom],
        render: {
          slideHeader: function slideHeader(_ref2) {
            var slide = _ref2.slide;
            return /*#__PURE__*/_jsx("div", {
              className: "absolute top-2 left-0 w-full bg-opacity-70 text-white font-bold py-2 text-center text-2xl z-50",
              children: slide.title
            });
          }
        }
      })]
    }), (videos === null || videos === void 0 ? void 0 : videos.length) > 0 && /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col mt-5",
      children: [/*#__PURE__*/_jsx("h4", {
        className: "z-10 text-xl mt-4 text-[#130E2F] mb-2 font-bold ".concat(config === null || config === void 0 ? void 0 : config.fontTitle),
        children: "Video"
      }), /*#__PURE__*/_jsx("div", {
        className: "z-10 grid grid-cols-1 md:grid-cols-7 lg:grid-cols-5 xl:grid-cols-7 auto-rows-fr w-full gap-2",
        children: videos.map(function (item, i) {
          return /*#__PURE__*/_jsx("div", {
            className: "".concat(i == 0 && videos.length > 10 ? "md:row-span-2 md:col-span-2 md:h-full" : "row-span-1 md:h-[100px] xl:h-[120px] ", " object-cover w-full cursor-pointer"),
            children: /*#__PURE__*/_jsx(ReactPlayer, {
              height: "100%",
              width: "100%",
              url: item.url,
              controls: true
            })
          }, item.url + i);
        })
      })]
    })]
  });
}